export const translation = {
    en: {
        accessibilityMenu: "Accessibility Menu",
        reset: "Reset",
        bigCursor: "Big Cursor",
        readingMask: "Reading Mask",
        hideImage: "Hide Image",
        highlightLink: "Highlight Link",
        increaseLetterSpace: "Increase Letter Space",
        increaseLineHeight: "Increase Line Height",
        darkContrast: "Dark Contrast",
        lightContrast: "Light Contrast",
        invertColor: "Invert Color",
        pageStructure: "Page Structure",
        leftAlign: "Left Align",
        rightAlign: "Right Align",
        lowSaturation: "Low Saturation",
        highSaturation: "High Saturation",
        desaturate: "Desaturate",
        links: "Links",
        headings: "Headings",
        language: "Language",
        english: "English",
        german: "German",
        portuguese: "Portuguese",
        currentLanguage: "English",
        magnify: "Magnify text",
    },
    de: {
        accessibilityMenu: "Barrierefreiheit-Menü",
        reset: "Zurücksetzen",
        bigCursor: "Großer Cursor",
        readingMask: "Lesemaske",
        hideImage: "Bild ausblenden",
        highlightLink: "Link hervorheben",
        increaseLetterSpace: "Buchstabenabstand vergrößern",
        increaseLineHeight: "Zeilenhöhe vergrößern",
        darkContrast: "Dunkler Kontrast",
        lightContrast: "Heller Kontrast",
        invertColor: "Farben umkehren",
        pageStructure: "Seitenstruktur",
        leftAlign: "Links ausrichten",
        rightAlign: "Rechts ausrichten",
        lowSaturation: "Geringe Sättigung",
        highSaturation: "Hohe Sättigung",
        desaturate: "Entsättigen",
        links: "Links",
        headings: "Überschriften",
        language: "Sprache",
        english: "Englisch",
        german: "Deutsch",
        portuguese: "Portugiesisch",
        currentLanguage: "Deutsch",
        magnify: "Text vergrößern",
    },
    pt: {
        accessibilityMenu: "Menu de accessibilidade",
        reset: "Redefinir",
        bigCursor: "Cursor grande",
        readingMask: "Máscara de leitura",
        hideImage: "Ocultar imagens",
        highlightLink: "Links destacados",
        increaseLetterSpace: "Espaçamento do texto",
        increaseLineHeight: "Altura da linha",
        darkContrast: "Contraste escuro",
        lightContrast: "Contraste claro",
        invertColor: "Inverter cores",
        pageStructure: "Estrutura da página",
        leftAlign: "Alinhamento à esquerda",
        rightAlign: "Alinhamento à direita",
        lowSaturation: "Baixa saturação",
        highSaturation: "Alta saturação",
        desaturate: "Dessaturar",
        links: "Links",
        headings: "Títulos",
        language: "Língua",
        english: "Inglês",
        german: "Alemão",
        portuguese: "Português",
        currentLanguage: "Português",
        magnify: "Text maior",
    },
};
//# sourceMappingURL=Language.js.map